import React from 'react'

import { css } from '@portal/styled-system/css'

import * as googleModel from '@/shared/lib/google-login/model'
import { useWatcher, useWatcherOnce } from '@/shared/lib/hooks'

import { renderGoogleButton } from '../lib'

type GoogleLoginButtonProps = {
    onSignin: (params: { accessToken: string }) => void
    width?: number
    height?: string
}

export function GoogleLoginButton(props: GoogleLoginButtonProps) {
    const googleButtonRef = React.useRef<HTMLDivElement>(null)

    useWatcher(googleModel.accessTokenReceived, ({ accessToken }) => props.onSignin({ accessToken }))

    useWatcherOnce(googleModel.$googleInitialized, (initialized) => {
        if (initialized && googleButtonRef.current) {
            renderGoogleButton({
                buttonRef: googleButtonRef.current,
                width: props.width,
                state: '',
            })
            return true
        }
        return false
    })

    return (
        <div
            // NOTE: added container width with overflow-x: hidden for correct mobile layout.
            // To be refactored with new design.
            className={css({
                [`@media screen and (max-width: 440px)`]: { width: 'full', overflowX: 'hidden' },
            })}
            ref={googleButtonRef}
            // biome-ignore lint/nursery/noInlineStyles: height is a runtime prop value
            style={{ height: props.height ?? '42px', marginBottom: '-2px' }}
        />
    )
}
